import { render } from "./MyLoading.vue?vue&type=template&id=7d052923&scoped=true"
import script from "./MyLoading.vue?vue&type=script&lang=js"
export * from "./MyLoading.vue?vue&type=script&lang=js"

import "./MyLoading.vue?vue&type=style&index=0&id=7d052923&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d052923"]])

export default __exports__